@if (rootModel()) {
<div class="content-tree">
    <span #menuTrigger style="position: fixed" [matMenuTriggerFor]="menu" [style.left]="menuPosition.x + 'px'"
        [style.top]="menuPosition.y + 'px'"></span>
    <app-content-node [model]='rootModel()'></app-content-node>
    <mat-menu #menu="matMenu">
        <ng-template matMenuContent let-component="component" let-menu="menu">
            <button mat-menu-item [disabled]="!menu.site" (click)="onSite()">
                <mat-icon>public</mat-icon>
                <span>New Site</span>
            </button>
            <button mat-menu-item [disabled]="!menu.genus" (click)="onGenus()">
                <mat-icon>note_add</mat-icon>
                <span>New Genus</span>
            </button>
            <button mat-menu-item [disabled]="!menu.folder" (click)="onFolder()">
                <mat-icon>create_new_folder</mat-icon>
                <span>New Folder</span>
            </button>
            <button mat-menu-item [disabled]="!menu.content" (click)="onContent()">
                <mat-icon>post_add</mat-icon>
                <span>Add Content</span>
            </button>
            <button mat-menu-item [disabled]="!menu.delete" (click)="onDelete(current)">
                <mat-icon>close</mat-icon>
                <span>Delete</span>
            </button>
            <button mat-menu-item [disabled]="!menu.cut" (click)="onCut(current)">
                <mat-icon>flip_to_front</mat-icon>
                <span>Cut</span>
            </button>
            <button mat-menu-item [disabled]="!menu.copy" (click)="onCopy(current)">
                <mat-icon>flip_to_back</mat-icon>
                <span>Copy</span>
            </button>
            <button mat-menu-item [disabled]="!menu.paste" (click)="onPaste()">
                <mat-icon>library_add</mat-icon>
                <span>Paste</span>
            </button>
        </ng-template>
    </mat-menu>
</div>
}
